<template>
  <router-link
    :to="{
      name: 'AnalyticsChart',
      params: { ...props.subGrafica, goBack }
    }"
    class="CardIndicator"
  >
    <div class="CardHeaderIndicator">
      <div
        v-if="props.subGrafica"
        style="height: 30px; padding-left: 10px; padding-right: 10px;"
      ></div>
    </div>
    <div
      style="flex-grow: 1; justify-content: space-evenly; margin-bottom: 10px;flex-direction: column;display: flex;"
    >
      <span
        style="text-align: center; font-style: 31px;"
        class="TextSubTitle FontsWhite"
      >
        {{ TextOrNumber(props.titulo, false, ".00") }}
      </span>
      <span
        style="text-align: center; font-style: 16px;"
        class="TextSubTitle FontsWhite"
      >
        {{ TextOrNumber(props.subtitulo, false, ".00") }}
      </span>
    </div>
  </router-link>
</template>

<script>
export default {
  name: "CardNumIndicator",
  props: {
    props: {
      type: Object,
      default: () => ({})
    }
  },
  computed: {
    goBack() {
      return this.$route?.params;
    }
  },
  methods: {
    TextOrNumber(str, ...rest) {
      return isNaN(str) ? str : this.$formatter(str, ...rest);
    }
  }
};
</script>

<style lang="scss" scoped>
.CardIndicator {
  background-color: #fb8e2c;
  border-radius: 16px;
  padding: 8px;
  height: 153px;
  min-width: 127px;
  margin-right: 10px;
  margin-top: 16px;
  margin-bottom: 8px;
  &:hover {
    text-decoration: none;
  }
}
.CardHeaderIndicator {
  flex-direction: row-reverse;
}
.TextSubTitle {
  font-weight: bold;
  font-size: 22px;
  color: #000;
}
.FontsWhite {
  color: #fff;
}
</style>
